module.exports = __webpack_public_path__ + "img/abilities.d8542669.svg";